@if (provincialRecyclabilityLabel && isRecyclabilityDataValid()) {
  <div class="product-info-container">
    <!-- Top Section with Product Name -->
    <div class="product-names">
      <span>{{ provincialRecyclabilityLabel.englishShortName }}</span>
      <span>{{ provincialRecyclabilityLabel.frenchShortName }}</span>
    </div>

    <!-- Middle Section with Recycling Icon -->
    <div class="recyclability-icon">
      <img [src]="recyclabilityIconPath" alt="Recycling Icon" />
    </div>

    <!-- Bottom Section with Labels -->
    <div class="recyclability-labels">
      <span>{{ englishRecyclabilityLabel }}</span>
      <span>{{ frenchRecyclabilityLabel }}</span>
    </div>
  </div>
}
